import brandedRoutes from '@/router/routes/branded'

export default function () {
  const paths = new URL(window.location.href).pathname.split('/').filter((x) => x)
  const branded_routes = brandedRoutes.map((x) => x.path.split('/').filter((x) => x)[1])
  const isSessionStorage = paths[0] === 'launch' || branded_routes.includes(paths[1])
  const prefex =
    import.meta.env.VITE_APP_INSTALLATION_TYPE === 'business'
      ? import.meta.env.VITE_APP_INSTALLATION_TYPE
      : isSessionStorage
        ? 'branded'
        : 'portal'
  return {
    key: (id) => `${prefex}_${id}`,
    storage: isSessionStorage ? sessionStorage : localStorage
  }
}
